import type { RefObject } from "react";
import { CHANNEL_ROW_HEIGHT } from "./ChannelRow.js";

// 32px timeline plus the 10px horizontal scrollbar kept by Chromium/WebKit.
// The rail and channel spacer must include the same total header footprint.
export const EPG_TIMELINE_HEADER_HEIGHT = 42;

interface EpgScrollRailProps {
  rowCount: number;
  scrollRef: RefObject<HTMLDivElement | null>;
}

/** The single vertical scrolling surface for guide rows, placed left of the guide. */
export function EpgScrollRail({ rowCount, scrollRef }: EpgScrollRailProps) {
  return (
    <div className="epg-scroll-rail" ref={scrollRef} aria-label="Scroll guide channels">
      <div
        className="epg-scroll-rail__content"
        style={{ height: rowCount * CHANNEL_ROW_HEIGHT + EPG_TIMELINE_HEADER_HEIGHT }}
      />
    </div>
  );
}
